<template>
  <div id="app">
    <router-view />
    <loading v-if="isLoading"></loading>
    <b-modal :active.sync="showAppSuggestion" has-modal-card>
      <app-suggestion-modal
        @closeAppSuggestion="showAppSuggestion = false"
      ></app-suggestion-modal>
    </b-modal>
  </div>
</template>

<script>
import loading from "./components/shared/Loading";
import { EventBus } from "./util/event-bus";
import App from "vue-chartjs/src/examples/App";
import AppSuggestionModal from "./components/misc/AppSuggestionModal";

export default {
  components: {
    AppSuggestionModal,
    App,
    loading,
  },

  data() {
    return {
      isLoading: false,
      showAppSuggestion: false,
    };
  },

  created() {
    EventBus.$on("showLoading", () => {
      this.isLoading = true;
    });

    EventBus.$on("hideLoading", () => {
      this.isLoading = false;
    });

    this.showAppSuggestion = window.mobileAndTabletcheck();
  },
};
</script>

<style lang="scss">
body {
  margin: 0;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}

.is-vertical-center {
  display: flex;
  align-items: center;
}
</style>
